import {createApp} from 'vue';
import {createBootstrap} from 'bootstrap-vue-next';
import SearchBar from "../../application/utility/SearchBar.vue";

$(document).ready(/\/student-management\/student\/\d*\/view$/.test(window.location.pathname)&&function() {
    const container = $('#search-bar-container');

    createApp(SearchBar, container.data())
        .use(createBootstrap())
        .mount(container[0]);
});
